import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconChevronDown = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="IconChevronDown"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M12 19.002a2 2 0 0 1-1.415-.587l-10-10A2.002 2.002 0 0 1 3.42 5.587l8.58 8.58 8.58-8.58a2.004 2.004 0 1 1 2.835 2.833l-10 10a2 2 0 0 1-1.414.58" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconChevronDown);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
